import { z } from 'zod';

const configSchema = z.object({
  adminTools: z.object({
    baseUrl: z.string(),
  }),
  api: z.object({
    baseUrl: z.string(),
  }),
  apiPublic: z.object({
    openAiCompatible: z.object({
      baseUrl: z.string(),
    }),
  }),
  branding: z
    .object({
      logo: z
        .object({
          lightUrl: z.string().optional(),
          darkUrl: z.string().optional(),
        })
        .optional(),
    })
    .optional(),
  chat: z.object({
    baseUrl: z.string(),
  }),
  experimental: z.object({}),
  featureFlags: z.object({
    maintenanceCheck: z.boolean(),
    provisionOrganizationApiBaseUrl: z.string().optional(),
  }),
  keycloak: z.object({
    baseUrl: z.string(),
    clientId: z.string(),
  }),
});

export type AppConfig = z.infer<typeof configSchema>;

let config: AppConfig;

export async function loadConfig(): Promise<void> {
  try {
    const response = await fetch('/config/config.json');

    if (!response.ok) {
      console.warn(
        `Failed to load config.json: ${response.status} ${response.statusText}`,
      );
      return;
    }

    const loadedConfig = (await response.json()) as AppConfig;

    const result = configSchema.safeParse(loadedConfig);

    if (result.success) {
      config = result.data;

      if (import.meta.env.DEV) {
        console.log('Configuration loaded successfully', config);
      }
    } else {
      console.error('Invalid configuration format:', result.error);
      console.warn('Using default configuration');
    }
  } catch (error) {
    console.error('Error loading configuration:', error);
    console.warn('Using default configuration');
  }
}

export function getConfig(): AppConfig {
  return config;
}
